/**
 * Papua New Guinean kina.
 */
export var PGK = {
  code: 'PGK',
  base: 10,
  exponent: 2
};